export const topics = [
    'Everyday Encounters',
    'Numbers',
    'Travel',
    'Food',
    'Work',
    'Banking',
    'Housing',
    'Healthcare',
    'Legal',
    'Slang',
    'Spanish Culture',
    'Emergencies',
    'Relationships',
    'Connectors & Conjunctions',
    'Idioms',
];
